import { __decorate, __extends } from "tslib";
import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";
var CouponMobile = /** @class */ (function (_super) {
    __extends(CouponMobile, _super);
    function CouponMobile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    //copyValue: string = this.couponCode;
    CouponMobile.prototype.dataLayerEvent = function () {
        //@ts-ignore
        window.dataLayer = window.dataLayer || [];
        //@ts-ignore
        window.dataLayer.push({
            'event': 'CouponGenerator',
            'eventCategory': 'CouponGenerator',
            'eventAction': 'copy',
            'eventLabel': this.couponCode
        });
    };
    CouponMobile.prototype.clipboardSelect = function () {
        try {
            var hiddenInput = this.$refs.hiddenInput;
            var editable = hiddenInput.contentEditable;
            var readOnly = hiddenInput.readOnly;
            hiddenInput.contentEditable = true;
            hiddenInput.readOnly = true;
            var range = document.createRange();
            range.selectNodeContents(hiddenInput);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
            hiddenInput.setSelectionRange(0, 999999);
            hiddenInput.contentEditable = editable;
            hiddenInput.readOnly = readOnly;
            document.execCommand('copy');
            this.dataLayerEvent();
        }
        catch (error) {
            console.error(error);
        }
    };
    CouponMobile.prototype.copyClick = function () {
        //@ts-ignore
        this.copyToClipboard();
        document.getElementById('lturCouponMobile-buttonCopy').style.display = 'none';
        document.getElementById('lturCouponMobile-buttonCopy_success').style.display = 'block';
    };
    CouponMobile.prototype.copyToClipboard = function () {
        var _this = this;
        if (navigator.clipboard !== undefined) {
            //@ts-ignore
            navigator.clipboard.writeText(this.couponCode).then(function () {
                /* clipboard successfully set */
                _this.dataLayerEvent();
            }, function () {
                /* clipboard write failed */
                _this.clipboardSelect();
            });
        }
        else {
            this.clipboardSelect();
        }
    };
    CouponMobile.prototype.showCouponOverlay = function () {
        var icon = document.getElementById('infoIcon');
        document.getElementById('lturCouponMobile-overlay').style.top = (icon.offsetTop + icon.offsetHeight) + 'px';
        document.getElementById('lturCouponMobile-overlay').style.width = icon.offsetLeft * 2 + 'px';
        document.getElementById('overlayArrow').style.left = icon.offsetLeft - icon.offsetWidth + 'px';
        document.getElementById('couponContent').style.overflow = 'visible';
        document.getElementById('lturCouponMobile-overlay').style.display = 'block';
        if (icon.offsetLeft > 158) {
            document.getElementById('lturCouponMobile-overlay').style.left = (icon.offsetLeft - 158) + 'px';
            document.getElementById('overlayArrow').style.left = 155.5 - icon.offsetWidth * 0.5 + 'px';
        }
    };
    CouponMobile.prototype.hideCouponOverlay = function () {
        document.getElementById('couponContent').style.overflow = 'hidden';
        document.getElementById('lturCouponMobile-overlay').style.display = 'none';
    };
    CouponMobile.prototype.mounted = function () {
        window.addEventListener('touchstart', function (event) {
            if (event.target.parentNode.parentNode != document.getElementById('lturCouponMobile-overlay')) {
                document.getElementById('couponContent').style.overflow = 'hidden';
                document.getElementById('lturCouponMobile-overlay').style.display = 'none';
            }
        });
    };
    __decorate([
        Prop({ default: false })
    ], CouponMobile.prototype, "showMobile", void 0);
    __decorate([
        Prop()
    ], CouponMobile.prototype, "claim", void 0);
    __decorate([
        Prop()
    ], CouponMobile.prototype, "couponCode", void 0);
    __decorate([
        Prop()
    ], CouponMobile.prototype, "language", void 0);
    __decorate([
        Prop()
    ], CouponMobile.prototype, "linkLabel", void 0);
    __decorate([
        Prop()
    ], CouponMobile.prototype, "linkUrl", void 0);
    __decorate([
        Prop()
    ], CouponMobile.prototype, "terms", void 0);
    __decorate([
        Prop()
    ], CouponMobile.prototype, "saving", void 0);
    __decorate([
        Prop()
    ], CouponMobile.prototype, "currencySymbol", void 0);
    __decorate([
        Prop()
    ], CouponMobile.prototype, "labelCopyCode", void 0);
    __decorate([
        Prop()
    ], CouponMobile.prototype, "labelCopyCodeSuccess", void 0);
    CouponMobile = __decorate([
        Component
    ], CouponMobile);
    return CouponMobile;
}(Vue));
export default CouponMobile;
